import React, { useEffect, useState } from 'react';
import { publicAxios } from '@/axios';
import { config } from '@/config';
import { XMLParser } from 'fast-xml-parser';
import { Document } from '@teo/components/icons';

export const CourseTreeImport = ({ activeCourse }) => {
  const [lessons, setLessons] = useState([]);
  useEffect(() => {
    if (activeCourse?.coursecontentId) {
      publicAxios
        .get(
          `${config.s3root}scorm/${activeCourse?.coursecontentId}/${activeCourse?.publicationPath}/imsmanifest.xml`
        )
        .then((result) => {
          const parser = new XMLParser({
            ignoreAttributes: false,
            isArray: (name) =>
              ['organization', 'resource', 'file', 'item'].includes(name),
          });
          const json = parser.parse(result.data);

          setLessons(json.manifest.organizations.organization[0].item);
        });
    }
  }, [activeCourse?.coursecontentId]);

  const renderItem2 = (item, indent = 0, i = 0) => {
    if (Array.isArray(item))
      return (
        <div className="flex max-h-[40vh] flex-col overflow-y-auto py-2">
          {item.map((x) => renderItem2(x, indent + 1, i + 1))}
        </div>
      );

    return (
      <div
        key={indent + '_' + i}
        className="rounded-md px-3 py-1 text-base text-black"
      >
        <div>
          <div className="my-1 flex items-center justify-between">
            <div
              className="flex min-h-[40px] w-full items-center"
              style={{ paddingLeft: '0px' }}
            >
              <div className="flex w-full items-center rounded-lg bg-grey-01 px-4 py-2 text-sm text-grey-08">
                <Document className={`m-1 w-5 min-w-5`} />
                <p className={'ml-1 block'}>{item.title}</p>
              </div>
            </div>
          </div>
        </div>
        {!!item.item && renderItem2(item.item, indent, 1)}
      </div>
    );
  };

  return <>{renderItem2(lessons, -1)}</>;
};
